import { AiOutlineFolder } from "react-icons/ai";

const FolderCloseIcon = ({ size }) => {
  return <AiOutlineFolder size={size} className="no-shrink" />;
};

export default FolderCloseIcon;
